import ScheduleDueDatesType from "@/models/Shared/ScheduleDueDatesType";

export default (scheduleDueDatesType: ScheduleDueDatesType) => {
    let returnVal = "Undefined";
    switch (scheduleDueDatesType) {
        case ScheduleDueDatesType.Interval:
            returnVal = "Interval";
            break;
        case ScheduleDueDatesType.FixedDaysOfMonth:
            returnVal = "Fixed Days Of Month";
            break;
    }
    return returnVal;
}